import { DatacenterV2 } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { DATACENTERS_URL } from '../constants/ApiUri';
import { ROUTES } from '../constants/RouteConstants';
import { quickActions } from '../mocks/Dashboard';
import { PageAction } from '../types/Common';
import { MapMarker } from '../types/Dashboard';

export default class DashboardAPI {
  public static getQuickActions = (): Promise<PageAction[]> => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(quickActions);
      }, 0);
    });
  };

  public static getMapData = async (): Promise<MapMarker[]> => {
    const datacenters = await Http.get<DatacenterV2[]>(DATACENTERS_URL);
    return datacenters.data.reduce((markers: MapMarker[], datacenter) => {
      const { dataCenterVmid, dataCenterName, primaryLocation } = datacenter;
      const [city, state, country, lat, lng] = primaryLocation.split(';');
      const location = `${city}${state ? `, ${state}` : ''}${
        country ? `, ${country}` : ''
      }`;
      const latitude = Number(lat);
      const longitude = Number(lng);
      const marker = markers.find(m => {
        const [oldLng, oldLat] = m.coordinates;
        if (
          Math.ceil(latitude * 100) === Math.ceil(oldLat * 100) &&
          Math.ceil(longitude * 100) === Math.ceil(oldLng * 100)
        ) {
          return true;
        }
        return false;
      });
      if (marker) {
        marker.children.push({
          id: dataCenterVmid,
          icon: 'datacenter-ico',
          name: dataCenterName,
          action: `${ROUTES.DATACENTERS}?dataCenterVmid=${dataCenterVmid}`,
          children: []
        });
      } else {
        markers.push({
          id: primaryLocation,
          icon: 'marker-ico',
          name: location,
          coordinates: [longitude, latitude],
          action: '',
          children: [
            {
              id: dataCenterVmid,
              icon: 'datacenter-ico',
              name: dataCenterName,
              action: `${ROUTES.DATACENTERS}?dataCenterVmid=${dataCenterVmid}`,
              children: []
            }
          ]
        });
      }
      return markers;
    }, []);
  };
}
